import moment from "moment-timezone";

export const convertDateToUserTimezone = (date, timezone) => {
    if (!date || !timezone) return null;
    return moment(date).tz(timezone).format("YYYY-MM-DD HH:mm:ss");
};

export const getDayInTimezone = (date, timezone) => {
    const m = convertDateToUserTimezone(date, timezone);
    if (!m) return null;
    return m.date();
};

export const getMonthInTimezone = (date, timezone) => {
    const m = convertDateToUserTimezone(date, timezone);
    if (!m) return null;
    return m.month() + 1;
};


export const getYearAccordingToBirthday = (dob, timezone = "UTC", birthTZ) => {
    if (!dob) return null
    const birth = moment(dob).tz(birthTZ);
    const today = moment().tz(timezone);

    const currentYear = today.year();

    const birthdayThisYear = moment.tz(
        `${currentYear}-${birth.month() + 1}-${birth.date()}`,
        "YYYY-M-D",
        timezone
    );

    if (today.isBefore(birthdayThisYear, "day")) {
        return currentYear - 1;
    }
    return currentYear;
};


export const getMonthAccordingToBirthdayDay = (dob, timezone, birthTZ) => {
    if (!dob || !timezone || !birthTZ) return null
    const birthDay = moment(dob).tz(birthTZ).date();
    const today = moment().tz(timezone);

    const currentMonth = today.month();
    const todayDay = today.date();

    if (todayDay < birthDay) {
        return currentMonth;
    }
    let nextMonth = currentMonth + 1;
    if (nextMonth > 12) nextMonth = 1;
    return nextMonth;
};

// export const getCurrentDayInTimezone = (timezone) => {
//     if (!timezone) return null;
//     return moment().tz(timezone).date();
// };

export const getPredictionYearByMonth = (
  dob,
  targetMonth,
  targetDay = null,
  timezone = "UTC",
  birthTZ
) => {
  if (!dob) return null;

  const birth = moment(dob).tz(birthTZ);
  const today = moment().tz(timezone);

  const birthMonth = birth.month() + 1;
  const birthDay = birth.date();

  const currentMonth = today.month() + 1;
  const currentDay = today.date();

  const currentYear = today.year();

  // Use current month/day if not provided
  const m = targetMonth || currentMonth;
  const d = targetDay || currentDay;

  // Birthday date this year
  const birthdayThisYear = moment.tz(
    `${currentYear}-${birthMonth}-${birthDay}`,
    "YYYY-M-D",
    timezone
  );

  const targetDateThisYear = moment.tz(
    `${currentYear}-${m}-${d}`,
    "YYYY-M-D",
    timezone
  );

  // If target date is BEFORE birthday this year → belongs to previous birthday cycle
  if (targetDateThisYear.isBefore(birthdayThisYear, "day")) {
    return currentYear + 1;
  }

  // After birthday → belongs to current→next cycle
  return currentYear;
};

export const getCurrentDayInTimezone = (timezone) => {
    if (!timezone) {
        return moment().date();
    }
    return moment().tz(timezone).date();
};

export const getCurrentMonthInTimezone = (timezone) => {
    if (!timezone) {
        return moment().month() + 1;
    }
    return moment().tz(timezone).month() + 1;
};

export const getCurrentYearInTimezone = (timezone) => {
    if (!timezone) {
        return moment().year();
    }
    return moment().tz(timezone).year();
};

export const convertDateToUserTimezoneWithTime = (date, timezone) => {
    if (!date || !timezone) return null;
    return moment(date)
        .tz(timezone)
        .format("MMMM DD, YYYY hh:mm A");
};


export function getPredictionRangeForYearly(birthDate, timezone) {
    if(!birthDate || !timezone) return null;
    const birth = moment.tz(birthDate, "YYYY-MM-DD", timezone);

    const birthDay = birth.date();
    const birthMonth = birth.month();
    const now = moment.tz(timezone);

    let thisYearBirthday = moment.tz(
        { year: now.year(), month: birthMonth, day: birthDay },
        timezone
    );

    let start;

    if (thisYearBirthday.isAfter(now, "day")) {
        start = thisYearBirthday.clone().subtract(1, "year");
    } else {
        start = thisYearBirthday.clone();
    }

    const end = start.clone().add(1, "year").subtract(1, "day");

    return {
        startDate: start.format("MM-DD-YYYY"),
        endDate: end.format("MM-DD-YYYY"),
    };
}

export function getPredictionRangeForMonthly(birthDate, month, year, timezone) {

    year = year || getCurrentYearInTimezone(timezone);
    year = year || getCurrentYearInTimezone(timezone);

    const birth = moment.tz(birthDate, "YYYY-MM-DD", timezone);
    const birthDay = birth.date();
    const birthMonth = birth.month();

    const start = moment.tz(
        { year, month: month - 1, day: birthDay },
        timezone
    );

    const end = start.clone().add(1, "month").subtract(1, "day");

    return {
        startDate: start.format("DD-MM-YYYY"),
        endDate: end.format("DD-MM-YYYY"),
    };
}

export function formatDate(input) {
  if (typeof input === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(input)) {
    const [month, day, year] = input.split('-');  
    input = new Date(year, month - 1, day);
  }

  const date = new Date(input);
  
  if (isNaN(date)) return null;

  const options = { 
    year: 'numeric', 
    month: 'short', 
    day: '2-digit' 
  };
  
  return date.toLocaleDateString('en-GB', options); 
}

export function getPredictionYearAccordingMonthAndDay({
  birthDate,
  birthTZ,
  currentTZ,
  month,
  day,
}) {
  const birth = moment.tz(birthDate, birthTZ);

  const birthMonth = birth.month() + 1; // 1–12
  const birthDay = birth.date();        // 1–31

  // Step 1: Base year from user’s current timezone
  const now = moment.tz(currentTZ);
  const baseYear = now.year();

  // Step 2: Determine what to compare
  const selectedMonth = month ?? (now.month() + 1);
  const selectedDay = day ?? 1; // if no day provided → monthly check

  // If only month is provided → compare month ONLY
  if (day == null) {
    // If selected month is before birth month → belongs to this year
    if (selectedMonth < birthMonth) {
      return baseYear;
    }

    // If selected month is after birth month → next year
    if (selectedMonth > birthMonth) {
      return baseYear + 1;
    }

    // If same month → depends on birth day
    return baseYear;
  }

  // If both month and day provided (full DAILY comparison)
  const selectedDate = moment.tz(
    `${baseYear}-${selectedMonth}-${selectedDay}`,
    currentTZ
  );

  const thisYearsBirthday = moment.tz(
    `${baseYear}-${birthMonth}-${birthDay}`,
    currentTZ
  );

  // Date comparison
  if (selectedDate.isBefore(thisYearsBirthday)) {
    return baseYear;  // before birthday
  }

  return baseYear + 1; // after birthday
}

export function getPredictionYear({
  birthDate,
  birthTZ,
  timezone,
  month,
  day,
}) {
  const now = moment().tz(timezone);

  const predMonth = month ?? now.month() + 1;
  const predDay = day ?? now.date();

  const bday = moment.tz(birthDate, birthTZ);
  const bMonth = bday.month() + 1;
  const bDay = bday.date();

  const currentYear = now.year();

  const isBeforeBirthday =
    predMonth < bMonth || (predMonth === bMonth && predDay < bDay);

  if (isBeforeBirthday) {
    return currentYear + 1;
  }

  return currentYear;
}


export function getPredictionYearForMonth({
  birthDate,
  birthTZ,
  timezone,
  month,
  day,
}) {
  const now = moment().tz(timezone);


  const bday = moment.tz(birthDate, birthTZ);
  const bMonth = bday.month() + 1;
  const bDay = bday.date();


  const predMonth = month ?? now.month() + 1;
  const predDay = bDay ?? now.date();

  const currentYear = now.year();

  const isBeforeBirthday =
    predMonth < bMonth || (predMonth === bMonth && predDay < bDay);

  if (isBeforeBirthday) {
    return currentYear + 1;
  }

  return currentYear;
}
